import Deferred from './index.js'
export = Object.assign(Deferred, { default: Deferred })
